import { sendRequest } from 'best-modules/vue-utils'
import { CommentCredentials, Comment } from '@/utils/types/comment'
import { PaginationList } from 'best-modules/components/server-table/types'

const commentList = (
  entityTypeId: number,
  entityId: number
): Promise<PaginationList<Comment>> => {
  return sendRequest({
    name: 'commentList',
    method: 'get',
    url: `/json/comment/byEntity/${entityTypeId}/${entityId}`,
  })
}

const commentCreate = (credentials: CommentCredentials): Promise<Comment> => {
  return sendRequest({
    name: 'commentCreate',
    method: 'post',
    url: '/json/comment',
    payload: credentials,
  })
}

const commentUpdate = (
  commentId: number,
  credentials: Omit<CommentCredentials, 'entityId' | 'entityTypeId'>
): Promise<Comment> => {
  return sendRequest({
    name: 'commentUpdate',
    method: 'put',
    url: `/json/comment/${commentId}`,
    payload: credentials,
  })
}

const commentDelete = (commentId: number): Promise<void> => {
  return sendRequest({
    name: 'commentDelete',
    method: 'delete',
    url: `/json/comment/${commentId}`,
  })
}

export { commentList, commentCreate, commentUpdate, commentDelete }
